import CheckoutAPService from "./CheckoutAPService";
import { ERROR_PROCESSING_AP_PAYMENT, SENTRY_ERRORS } from "../../app-constants";
import { getRandomInvoiceNumber } from "@/utils";
import { mapFPAPResponseMapper } from "@/../api/mappers/FPAPResponseMapper";
import errorLoggerAdapter from "@/adapters/errorLoggerAdapter";

class CheckoutFPAPService extends CheckoutAPService {
  constructor(payload, dispatch, commit) {
    super(payload, dispatch, commit, true);
  }

  /**
   * Upon successful ApplePayment, send payment token through connect checkout.
   * @param paymentData
   * @param billingContact
   * @returns {Promise<void>}
   */
  async processAPToken(paymentData, billingContact) {
    try {
      this.commit("payments/setFPPaymentKey", "", { root: true });
      const invoiceNumber = getRandomInvoiceNumber();
      const nameOnCard = billingContact ? `${billingContact.givenName} ${billingContact.familyName}` : null;
      const processCCPayload = {
        invoiceNumber: invoiceNumber,
        payment: this.payload,
        nameOnCard,
        pos: {
          cardPresent: "N",
          entryMode: "inapp",
          encMode: "applewallet",
          msrType: "applepay",
          tracke: paymentData
        }
      };

      const xmlResponse = await this.dispatch("processCreditCardCapture", processCCPayload);
      const paymentPayload = Object.assign({}, this.payload, {
        debitExternalData: mapFPAPResponseMapper(xmlResponse, invoiceNumber)
      });

      const { order, data } = await this.dispatch("checkoutCreditCard", paymentPayload);

      if (data && !data.success) {
        errorLoggerAdapter.createIssue(
          SENTRY_ERRORS.ERROR_FP_AP_PROCESS,
          "checkoutError",
          "CheckoutFPAPService.processAPToken.response",
          {
            description: JSON.stringify(data)
          }
        );

        this.onErrorCB(ERROR_PROCESSING_AP_PAYMENT);
        this.applePaySession.abort();
        return;
      }

      this.onSuccessCB(order);
      this.applePaySession.completePayment(ApplePaySession.STATUS_SUCCESS);
    } catch (error) {
      errorLoggerAdapter.createIssue(
        SENTRY_ERRORS.ERROR_FP_AP_PROCESS,
        "checkoutError",
        "CheckoutFPAPService.processFPAPToken.catch",
        { description: error.toString() },
        error
      );

      this.onErrorCB(ERROR_PROCESSING_AP_PAYMENT);
      this.applePaySession.abort();
    }
  }
}

export default CheckoutFPAPService;
